import React from 'react';
import classNames from 'classnames';
import styles from './ToggleGroup.module.scss';

export interface ToggleOption<T extends string = string> {
	key: T;
	label: string;
}

interface ToggleGroupProps<T extends string = string> {
	options: ToggleOption<T>[];
	value: T;
	onChange: (value: T) => void;
	className?: string;
}

function ToggleGroup<T extends string = string>({
	options,
	value,
	onChange,
	className
}: ToggleGroupProps<T>): React.ReactElement {
	return (
		<div className={classNames(styles.container, className)}>
			{options.map((option) => (
				<button
					key={option.key}
					className={classNames(styles.option, {
						[styles['option--active']]: value === option.key
					})}
					onClick={() => onChange(option.key)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
}

export default ToggleGroup;
